import { IS_ANDROID } from './constants/env';

const getPlatformUri = (uri) => {
  return IS_ANDROID ? uri : uri.replace('file://', '');
};
export default getPlatformUri;
